/** @format */

import { useState, useEffect } from "react";
import axios from "axios";
import Login from "./pages/login/Login";
import Respublika from "./pages/republik/index";
import Region from "./pages/region/index";
import Itb from "./pages/itb/index";
import District from "./pages/district/index";
import PrivacyPolicy from "./pages/supportPage";
import { getEnv } from "./lib/env";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("sw_user_token");

  useEffect(() => {
    const checkAuth = async () => {
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const res = await axios.get(`${getEnv('REACT_APP_BASE_URL')}/v1/users/me`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const localData = JSON.parse(localStorage.getItem("sw_user"));
        const backendUser = res.data;
        if (localData && localData.target !== backendUser.target) {
          console.warn("Xavfsizlik: Target mos kelmadi. Sessiya tugatildi.");
          handleForceLogout();
          return;
        }
        setUser(backendUser);
        localStorage.setItem("sw_user", JSON.stringify(backendUser));
      } catch (err) {
        console.error("Avtorizatsiya xatosi:", err);
        handleForceLogout();
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [token]);

  const handleForceLogout = () => {
    localStorage.removeItem("sw_user");
    localStorage.removeItem("sw_user_token");
    setUser(null);
    setLoading(false);
  };

  if (window.location.pathname === "/privacy") return <PrivacyPolicy />;
  if (loading) return <div className="loading-screen">Yuklanmoqda...</div>;
  
  if (!token || !user) return <Login />;

  const renderPage = (target) => {
    switch (target) {
      case "respublika": return <Respublika />;
      case "viloyat": return <Region />;
      case "itb": return <Itb />;
      case "tuman": return <District />;
      default: 
        handleForceLogout();
        return <Login />;
    }
  };

  return <div className='App'>{renderPage(user.target)}</div>;
}

export default App;